// tslint:disable
// This file is generated by generateBalancingMaps script.
// Please don't edit it manually.
// prettier-ignore
export var buildingsByProducedResourceId = new Map([
    [3, [7, 30]],
    [4, [7, 30]],
    [5, [7, 30]],
    [6, [7, 30]],
    [78, [7, 30]],
    [79, [7, 30]],
    [301, [7, 30]],
    [2, [7, 30]],
    [1, [7, 30]],
    [267, [7, 30]],
    [10, [9, 32, 127, 185]],
    [13, [9, 32, 127, 185, 10, 33, 128, 11, 106, 129, 186, 66, 107, 153, 67, 108, 154, 203]],
    [11, [10, 33, 128]],
    [12, [11, 106, 129, 186]],
    [90, [66, 107, 153]],
    [91, [67, 108, 154]],
    [15, [13, 159, 194]],
    [17, [13, 159, 194, 14, 68, 195, 69, 163, 196, 70, 197]],
    [264, [13, 159, 194, 14, 68, 195, 69, 163, 196, 70, 197]],
    [16, [14, 68, 195]],
    [93, [69, 163, 196]],
    [94, [70, 197]],
    [7, [8]],
    [8, [8]],
    [9, [8]],
    [84, [8]],
    [85, [8]],
    [302, [8]],
    [14, [12]],
    [18, [15]],
    [224, [155]],
    [226, [155]],
    [221, [155]],
    [225, [155]],
    [223, [155]],
    [227, [155]],
    [222, [155]],
    [228, [156]],
    [229, [156]],
    [230, [156]],
    [231, [156]],
    [232, [156]],
    [233, [156]],
    [234, [156]],
    [307, [156]],
    [308, [156]],
    [309, [156]],
    [265, [187]],
    [268, [187]],
    [306, [203]],
    [159, [122]],
    [160, [122]],
    [161, [122]],
    [162, [122]],
    [163, [122]],
    [164, [122]],
    [132, [112]],
    [133, [112]],
    [134, [112]],
    [146, [114]],
    [151, [114, 115, 140, 141, 172, 173]],
    [147, [115]],
    [148, [116]],
    [156, [116, 117, 118, 142, 143, 144, 174, 175, 176]],
    [149, [117]],
    [150, [118]],
    [138, [119]],
    [139, [119]],
    [152, [120, 146, 178]],
    [157, [121, 147, 179]],
    [196, [132]],
    [197, [132]],
    [198, [132]],
    [199, [132]],
    [200, [132]],
    [201, [132]],
    [180, [136]],
    [181, [136]],
    [182, [136]],
    [191, [140]],
    [192, [141]],
    [193, [142]],
    [194, [143]],
    [195, [144]],
    [183, [145]],
    [184, [145]],
    [256, [166]],
    [257, [166]],
    [258, [166]],
    [259, [166]],
    [260, [166]],
    [261, [166]],
    [104, [170]],
    [112, [170]],
    [118, [170]],
    [251, [172]],
    [252, [173]],
    [253, [174]],
    [254, [175]],
    [255, [176]],
    [206, [177]],
    [244, [177]],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/balancing/types/buildingsByProducedResourceId.ts
// module id = 593
// module chunks = 3